import type { SITE_AUTODIAG_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-autodiag-card/site-autodiag-card.fr.ts";

export const SITE_AUTODIAG_CARD_ENGLISH_LOCALE = {
  title: "Realtime diagnostic",
  warning:
    'Before any diagnosis, make sure that all the circuit breakers on the electrical panel are ON (or in raised position) and click on "Synchronize MyV programming"',
} satisfies typeof SITE_AUTODIAG_CARD_FRENCH_LOCALE;
